export const NuxtApollo = {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge": 604800, "secure": true, "sameSite": "lax"},
 clients: {"default": {"httpEndpoint": "https://wp.livebouldercreek.com/wp/graphql", "connectToDevTools": true, "defaultOptions": {"query": {"errorPolicy": "all"}, "watchQuery": {"errorPolicy": "all"}}, "authType": "Bearer", "authHeader": "Authorization", "tokenName": "apollo:default.token", "tokenStorage": "cookie"}}
}